import { lazy } from "react";
import AuthGuard from "routes/AuthGuard";
import Loadable from "routes/Loadable";
import AdminLayout from "components/layouts/adminLayout";

//Others Income
const Category = Loadable(lazy(() => import("pages/others-income/Category")));
const Add = Loadable(lazy(() => import("pages/others-income/Add")));
const Receipt = Loadable(lazy(() => import("pages/others-income/Receipt")));
const OthersIncome = Loadable(lazy(() => import("pages/others-income")));
const CategoryReport = Loadable(lazy(() => import("pages/others-income/CategoryReport")));

const OthersIncomeRoutes = {
  path: "others-income",
  element: (
    <AuthGuard>
      <AdminLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "category",
      element: <Category />,
    },
    {
      path: "add",
      element: <Add />,
    },
    {
      path: "receipt/:incomeId",
      element: <Receipt />,
    },
    {
      path: "list",
      element: <OthersIncome />,
    },
    {
      path: "report/category",
      element: <CategoryReport />,
    },
  ],
};

export default OthersIncomeRoutes;
